import React from 'react';

import { KeyOutlined, ApiOutlined } from '@ant-design/icons';
import { Form, Input, Alert, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';

import { useDirtyMaskedField } from '@hooks/shared/useDirtyMaskedField';

const BvShopCredentials = ({ form, ecAccount }) => {
  const { t } = useTranslation();

  const isEditing = !!ecAccount?.id;
  const accessTokenDirty = useDirtyMaskedField(form, [ 'credentials', 'access_token' ], isEditing);

  return (
    <div>
      <Alert
        message={t('models.ec_account.platform_settings.bv_shop.contact_support')}
        type="info"
        showIcon
        style={{ marginBottom: '16px' }}
      />

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name={['credentials', 'api_domain']}
            label={t('models.ec_account.platform_settings.bv_shop.api_domain')}
            rules={[
              { required: true, message: t('models.ec_account.platform_settings.bv_shop.api_domain_required') },
              { pattern: /^https:\/\/.*/, message: t('models.ec_account.platform_settings.bv_shop.api_domain_pattern') }
            ]}
          >
            <Input
              placeholder={t('models.ec_account.platform_settings.bv_shop.api_domain_placeholder')}
              prefix={<ApiOutlined />}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['credentials', 'access_token']}
            label={t('models.ec_account.platform_settings.bv_shop.access_token')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.bv_shop.access_token_required') }]}
          >
            <Input.Password
              autoComplete="new-password"
              placeholder={t('models.ec_account.platform_settings.bv_shop.access_token_placeholder')}
              prefix={<KeyOutlined />}
              visibilityToggle={accessTokenDirty}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default BvShopCredentials;
